export function getView(is_hovered, is_submitting) {
  return is_hovered || is_submitting ? 'Action' : 'No'
}
